export default __webpack_public_path__ + "static/media/yoga-icon.3e83ea64.svg";